import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';
import { RequestHeaders } from 'src/app/models/request-headers.enum';

@Injectable()
export class FailoverInterceptor implements HttpInterceptor {
  constructor(private apiService: ApiService) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          request.headers.get(RequestHeaders.server) != null
        ) {
          return this.failover(request, next, error);
        } else {
          return throwError(error);
        }
      })
    );
  }

  private failover(
    request: HttpRequest<any>,
    next: HttpHandler,
    error: HttpErrorResponse
  ) {
    switch ((error as HttpErrorResponse).status) {
      case 0:
      case 404:
      case 500:
      case 503: {
        const type = request.headers.get(RequestHeaders.server);

        let retries = parseInt(request.headers.get(RequestHeaders.retries));
        if(Number.isNaN(retries)) retries = 0;

        const baseUrl = this.apiService.parseUrl(request.url, ServerTypes[type]);

        // The url does not belong to this pool, so we cannot split off a sub
        // address: rewriting would produce `<otherServer><wholeOriginalUrl>`,
        // and rotating would move a pool that never failed. Let the error through.
        if (!baseUrl) return throwError(error);

        const subAddress = request.url.replace(baseUrl, '');

        const headers = request.headers.set(RequestHeaders.retries, (retries + 1).toString());

        this.apiService.updateApi2(ServerTypes[type]);

        if (retries < 1) { // skip this for now
        
          const newReq = request.clone({
            url:
              this.apiService.getCurentServer(ServerTypes[type]) + subAddress,
            headers,
          });

          return next.handle(newReq).pipe(
            catchError((err) => {
              if (error instanceof HttpErrorResponse) {
                return this.failover(newReq, next, err);
              } else {
                return throwError(error);
              }
            })
          );
        }
      }
    }
    return throwError(error);
  }
}
